import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { setAlert } from '../../actions/alert';
import { obtenerBloqueo, editarBloqueo } from '../../actions/citas';
import { buscarLocatarios } from '../../actions/locatarios';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const EditarBloqueo = ({ bloqueo, reestablecerBloqueo }) => {

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.locatarios);
    const { detalles } = useSelector(state => state.citas);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [bloqueoData, setBloqueoData] = useState({
        id_locatario: null,
        motivo: null, 
        fecha_inicio: null,
        fecha_fin: null
    });

    const [locatarioData, setLocatarioData] = useState(null);
    const [locatariosFilter, setLocatariosFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Editar bloqueo */
    const handleSelectLocatario = (option) => {
        setLocatarioData(option);

        setBloqueoData({
            ...bloqueoData,
            id_locatario: option.value
        });
    }

    const handleInputChange = ({ target }) => {
        setBloqueoData({
            ...bloqueoData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setBloqueoData({
            ...bloqueoData,
            [name]: value
        });
    }
    
    const handleProcesar = async () => {
        if(bloqueoData.motivo){
            if(bloqueoData.id_locatario){
                if((new Date(bloqueoData.fecha_inicio) <= new Date(bloqueoData.fecha_fin)) && new Date(bloqueoData.fecha_inicio) && new Date(bloqueoData.fecha_inicio)){
                    await setStatusProcesar(true);
                    await dispatch(editarBloqueo(bloqueoData));
                    await handleCerrar();
                    await setStatusProcesar(false);
                }else{
                    await dispatch(setAlert('La fecha de inicio debe ser menor o igual a la de finalización', 'danger'));
                }
            }else{
                await dispatch(setAlert('Selecciona un locatario', 'danger'));
            }
        }else{
            await dispatch(setAlert('Ingresa el motivo de bloqueo de fechas', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setBloqueoData({
                id_locatario: null,
                motivo: null, 
                fecha_inicio: null,
                fecha_fin: null
            });

            setLocatarioData(null);
            setNuevoModal(false);
            reestablecerBloqueo(null);
        }
    }

    useEffect(() => {
        dispatch(buscarLocatarios({
            nombre: null,
            servicio: null,
            status: null,
            fecha_inicio: null,
            fecha_fin: null
        }));
    }, []);

    useEffect(() => {
        if(bloqueo){
            setNuevoModal(true);

            dispatch(obtenerBloqueo(bloqueo?.id));

            setBloqueoData({
                ...bloqueoData,
                id: bloqueo?.id
            });
        }        
    }, [bloqueo]);

    useEffect(() => {
        if(detalles){
            setBloqueoData({
                ...bloqueoData,
                id: detalles?._id, 
                id_locatario: detalles?.locatario?._id,
                motivo: detalles?.motivo, 
                fecha_inicio: detalles?.fecha_inicio,
                fecha_fin: detalles?.fecha_fin
            });

            if(locatariosFilter.length > 0){

                let locatario_elegido = locatariosFilter.find( locatario => String(locatario.value) === String(detalles?.locatario?._id) );
    
                if(locatario_elegido){
                    setLocatarioData({value: locatario_elegido.value, label: locatario_elegido.label});
                }
            }
        }
    }, [detalles]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado?.length; i++) {
            options.push({ value: listado[i]._id, label: listado[i].servicio + ' (' + listado[i].nombre + ')', horarios: listado[i].horarios, bloqueos: listado[i].bloqueos });
        }

        if(usuario?.tipo == 2){
            options = options.filter(o => String(o.value) === String(usuario.locatario));
        }

        setLocatariosFilter(options);
    }, [listado]);

    return (
        <Modal show={nuevoModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar bloqueo de disponibilidad</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Motivo" id="motivo" name="motivo" value={bloqueoData.motivo} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="motivo">Motivo</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_locatario"
                                name="id_locatario"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar locatario"
                                isClearable
                                options={locatariosFilter}
                                value={locatarioData}
                                onChange={(value) => handleSelectLocatario(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    selected={ bloqueoData.fecha_inicio != null ? new Date(bloqueoData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha de inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    selected={ bloqueoData.fecha_fin != null ? new Date(bloqueoData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha de finalización</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarBloqueo;